import { fetchTransport } from 'util/core/transport/fetch.transport'
import { type Profile } from 'data-access/market/type/market-product-type'

class DataAccessProfiles {
  public async loadProfileById (
    id: string
  ): Promise<Profile> {
    const response = await fetchTransport.get({
      url: `/api/profiles/${id}`
    })

    if (response.status >= 400 && response.status < 600) {
      throw new Error(
        response.status.toString()
      )
    }

    return await response.json() as Profile
  }

  public async loadProfilesByIds (
    ids: string[]
  ): Promise<Profile[]> {
    const profilePromises = ids.map(async id => {
      const response = await fetchTransport.get({ url: `/api/profiles/${id}` })
      return response.json() as Profile
    })
    const profiles: Profile[] = await Promise.all(profilePromises)
    return profiles
  }

  public async loadProfiles (
    filters: {
      page: number
      perPage: number
      pagination?: boolean
      relatedCategoryId?: string
    }
  ): Promise<any> {
    const params = new URLSearchParams()
    params.append('page', String(filters.page))
    params.append('perPage', String(filters.perPage))
    if (filters.pagination) {
      params.append('pagination', String(filters.pagination))
    }
    if (filters.relatedCategoryId) {
      params.append('relatedCategoryId', filters.relatedCategoryId)
    }
    const response = await fetchTransport.get({
      url: '/api/profiles',
      searchParams: params
    })
    if (response.status >= 400 && response.status < 600) {
      throw new Error(
        response.status.toString()
      )
    }

    const json = await response.json()
    const result = {
      items: [],
      total: 0
    }

    if (json['@type'] === 'hydra:Collection') {
      if (json['hydra:member'].length > 0) {
        result.total = json['hydra:totalItems']
        result.items = json['hydra:member']
      }
    }

    return result
  }
}

export const dataAccessProfiles = new DataAccessProfiles()
